<template>
  <section>
    <div v-if="hasProfileOnBeNeat">
      <i class="fas fa-sticky-note text-info"></i> โน้ตในระบบ
      <a href="" @click.prevent="openAddNoteModal()"><i class="fas fa-pencil-alt"></i></a>
      <b-button v-b-toggle.collapse-2 class="m-1 btn-sm float-right">{{ isOpenCollapsed ? 'ปิด' : 'เปิด' }}</b-button>
    </div>

    <b-collapse id="collapse-2" @hidden="isOpenCollapsed = false" @shown="isOpenCollapsed = true">
      <div class="mt-3" v-if="notes && notes.length > 0">
        <div class="box-body table-responsive">
          <table
            class="table table-striped"
            style="font-size: 75%"
            v-if="profileType === 'customer'">
            <thead>
            <tr class="info">
              <th class="text-center">Date</th>
              <th>Comment</th>
              <th></th>
              <th>Name</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(note, index) in notes" :key="'note_' + index">
              <td class="text-center">{{ note.created_at | prettyDate }}</td>
              <td>{{ note.comment }}</td>
              <td>
                <template v-if="note.user_note_picture && note.user_note_picture.length > 0">
                  <template v-for="(picture, index) in note.user_note_pictures">
                    <div
                      class="more-image"
                      :key="picture.id"
                      v-show="index === 0">
                      <img
                        v-img="{ group: note.id }"
                        :src="picture.picture_url"
                        alt=""
                        width="50"
                        v-if="picture.picture_url"/>
                      <span v-if="note.user_note_pictures.length > 1">+ {{ note.user_note_pictures.length - 1 }}</span>
                    </div>
                  </template>
                </template>
              </td>
              <td>
                {{ note.admin && note.admin.name ? note.admin.name : '' }}
              </td>
            </tr>
            </tbody>
          </table>
          <table
            class="table table-striped"
            style="font-size: 75%"
            v-if="profileType === 'professional'">
            <thead>
            <tr class="info">
              <th class="text-center">Date</th>
              <th>Comment</th>
              <th></th>
              <th>Name</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(note, index) in notes" :key="'note_' + index">
              <td class="text-center">{{ note.created_at | prettyDate }}</td>
              <td>{{ note.comment }}</td>
              <td>
                <template v-if="note.prof_note_picture && note.prof_note_picture.length > 0">
                  <template v-for="(picture, index) in note.prof_note_picture">
                    <div
                      class="more-image"
                      :key="picture.id"
                      v-show="index === 0">
                      <img
                        v-img="{ group: note.id }"
                        :src="picture.picture_url"
                        alt=""
                        width="50"
                        v-if="picture.picture_url"/>
                      <span v-if="note.prof_note_picture.length > 1">+ {{ note.prof_note_picture.length - 1 }}</span>
                    </div>
                  </template>
                </template>
              </td>
              <td>
                {{ note.admin && note.admin.name ? note.admin.name : '' }}
              </td>
            </tr>
            </tbody>
          </table>
          <table
            class="table table-striped"
            style="font-size: 75%"
            v-if="profileType === 'applicant'">
            <thead>
            <tr class="info">
              <th class="text-center">Date</th>
              <th class="text-center">P</th>
              <th>Comment</th>
              <th></th>
              <th>Name</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(note, index) in notes" :key="'note_' + index">
              <td class="text-center">{{ note.created_at | prettyDate }}</td>
              <td class="text-center">{{ note.p_value | pValue }}</td>
              <td>{{ note.comment }}</td>
              <td>
                <img
                  v-img="{ group: note.id }"
                  :src="note.image_url"
                  style="height: 40px"
                  class="img-responsive center-block"
                  alt=""
                  v-if="note.image_url"/>
              </td>
              <td>{{ note.admin_name ? note.admin_name : '' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-collapse>

    <sweet-modal ref="addNoteModal" overlay-theme="dark">
      <div class="text-left">
        <div class="form-group" v-if="profileType === 'applicant'">
          <label class="form-label" for="p">P</label>
          <div class="input-group">
            <select name="" id="" class="form-control" v-model="submitData.p_value">
              <option :value="100">{{ 100 | pValue }}</option>
              <option :value="90">{{ 90 | pValue }}</option>
              <option :value="80">{{ 80 | pValue }}</option>
              <option :value="50">{{ 50 | pValue }}</option>
              <option :value="40">{{ 40 | pValue }}</option>
              <option :value="0">{{ 0 | pValue }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label" for="comment">Comment</label>
          <div class="input-group">
            <textarea id="comment" :class="'form-control'" name="comment" v-model="submitData.comment">
            </textarea>
          </div>
        </div>
        <div class="form-group" v-if="profileType === 'customer' || profileType === 'professional'">
          <label class="form-label" for="files">แนบไฟล์</label><span class="text-muted"> (Optional)</span>
          <div class="input-group">
            <input id="files" name="files" ref="files" @change="updatePictureHandler($event)" type="file" multiple accept="image/*"/>
            <span class="ml-2" v-if="files.length > 0">{{ files.length }} รูป</span>
          </div>
        </div>
        <div class="form-group" v-else-if="profileType === 'applicant'">
          <label class="form-label" for="file">แนบไฟล์</label><span class="text-muted"> (Optional)</span>
          <div class="input-group">
            <input type="file" class="form-control"
                   id="file"
                   name="file"
                   ref="file">
          </div>
        </div>
        <div class="text-right mt-4">
          <button class="btn btn-success" @click="saveNote()">Submit
          </button>
        </div>
      </div>
    </sweet-modal>
  </section>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    notes: Array,
    customer: Object,
    profileType: String
  },
  data () {
    return {
      files: [],
      submitData: {
        p_value: '',
        comment: ''
      },
      isOpenCollapsed: false
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    hasProfileOnBeNeat () {
      let result = false
      if (this.customer && (this.customer.customer || this.customer.professional || this.customer.applicant)) {
        return true
      }
      return result
    }
  },
  methods: {
    ...mapActions('conversation', ['fetchNotes']),
    openAddNoteModal () {
      this.submitData = {
        comment: '',
        p_value: ''
      }
      if (this.admin) {
        this.submitData.admin_id = this.admin.beneat_admin_id
      }
      if (this.profileType === 'applicant' && this.customer && this.customer.applicant) {
        this.submitData.professional_register_id = this.customer.applicant.id
      }
      this.$refs.addNoteModal.open()
    },
    updatePictureHandler (event) {
      let files = event.target.files
      if (files.length > 0) {
        this.files = files
      }
    },
    async saveNote () {
      if (!this.submitData.comment) {
        alert('กรุณาใส่ข้อมูลให้ครบถ้วน')
        return
      }
      if (this.profileType === 'customer') {
        let formData = new FormData()
        formData.append('user_id', this.customer.customer.id)
        formData.append('admin_id', this.submitData.admin_id)
        formData.append('comment', this.submitData.comment)

        if (this.files) {
          for (let i = 0; i < this.files.length; i++) {
            formData.append('files[]', this.files[i])
          }
        }
        await axios.post(`/beneat/users/${this.customer.customer.id}/note/save`, formData)
      } else if (this.profileType === 'professional') {
        let formData = new FormData()
        formData.append('professional_id', this.customer.professional.id)
        formData.append('admin_id', this.submitData.admin_id)
        formData.append('comment', this.submitData.comment)
        formData.append('eloquent', 1)

        if (this.files) {
          for (let i = 0; i < this.files.length; i++) {
            formData.append('files[]', this.files[i])
          }
        }
        await axios.post(`beneat/professionals/${this.customer.professional.id}/note/save`, formData, { withCredentials: false })
      } else if (this.profileType === 'applicant') {
        if (this.submitData.p_value === '') {
          alert('กรุณาใส่ข้อมูลให้ครบถ้วน')
          return
        }
        const file = this.$refs.file.files[0]
        let formData = new FormData()
        if (file) {
          formData.append('image_url', file)
        }
        Object.entries(this.submitData).forEach(([key, value]) => formData.append(key, value))
        await axios.post('beneat/professionals/register/note', formData)
        this.$refs.file.values = ''
      }

      let params = {}
      let url = ''
      if (this.profileType === 'customer') {
        url = `beneat/users/${this.customer.customer.id}/note`
      } else if (this.profileType === 'professional') {
        url = `beneat/professionals/${this.customer.professional.id}/note`
      } else if (this.profileType === 'applicant') {
        url = 'beneat/professionals/register/note'
        params = {
          professional_register_id: this.customer.applicant.id
        }
      }
      const payload = {
        url,
        params,
        profile_type: this.profileType
      }
      this.$refs.addNoteModal.close()
      await this.fetchNotes(payload)
    }
  }
}
</script>

<style lang="scss">
div.more-image {
  width: 50px;
  position: relative;
  cursor: pointer;

  span {
    position: absolute;
    color: white;
    bottom: 0;
    right: 0;
    background: orange;
  }
}
</style>
